module.exports = [{"type":"hash","text":"連接限制"},{"type":"normal","text":"一個websocket限制最多200個topic，超過將返回80403錯誤碼。"},{"type":"normal","text":"一個IP限制最多60個websocket，超過將建立連結失敗。"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/swapV2/websocket/introduce/00_limit.json
// module id = u2Il
// module chunks = 3